import { Controller } from '@hotwired/stimulus';

export default class ReasonKind extends Controller {
  static targets = [
    'reasonKind',
    'reasonDetail',
    'checkbox'
  ];

  checkboxChanged() {
    this.reasonKindTarget.disabled = !this.checkboxTarget.checked;
    this.reasonDetailTarget.disabled = !this.checkboxTarget.checked || this.reasonKindTarget.value !== 'other';
  }

  reasonKindChanged() {
    this.reasonDetailTarget.disabled = this.reasonKindTarget.value !== 'other';
  }
}
